export async function delay(delayAmount = 300) {
  return new Promise((resolve) => setTimeout(resolve, delayAmount));
}
